import Vue from 'vue'
import axios from 'axios'
import {Cookies} from "quasar-framework"

Vue.use({
    install() {
        Vue.prototype.$login = function (slug) {
            let portal = Cookies.get('portal');
            slug = (slug == undefined || slug ==""  )? "/" : slug
            slug = config.appUrlPortal.replace("/", "*").replace("/", "*")+'*'+slug.replace("/", "")
            // Submit the form.
            axios.post(`${config.SkySMSUrl}/login`,{redirectTo: slug, portal: portal}).then(function(response){
                window.location.href = response.data;

            })
            // this.$store.dispatch('local/set', { key: 'login', value: true })
            // this.$store.dispatch('local/set', { key: 'redirect-route', value: slug })
        }
    }
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/login.js